import { Record, List } from 'immutable';

export const deviceFactory = new Record({
  deviceId: '',
  deviceType: '',
  displayGuid: '',
  erpType: '',
});

export const devicesFactory = (messages) => List(messages.map(deviceFactory));
